import Grid  from "@mui/material/Grid"
import React, { FC } from "react"
import { CustomTooltip } from "../../../../../../../../components/tooltip"

export interface DetailItemProps {
  mainText: string
  secontaryText: string
  tooltipText?: string
  variant?: string
  weightColor?: string
  weightColorSecondary?: string
  id?: string;
}

export const DetailItem: FC<DetailItemProps> = ({ mainText, secontaryText, tooltipText, variant = 'tinyText', weightColor = '400', weightColorSecondary = '400', id = '' }) => {
  return (
    <Grid container justifyContent='space-between' alignItems='flex-end' className='bp-mt-8'>
      <Grid item xs={6}>
        <pichincha-typography variant={variant} color="darkGrey" weight_color={weightColor}>
          {mainText}
        </pichincha-typography>
      </Grid>
      <Grid item xs={6}>
        <Grid container justifyContent='flex-end'>
          <pichincha-typography id={id} variant={variant} color="darkGrey" class="detailTerm" weight_color={weightColorSecondary}>
            {secontaryText}
          </pichincha-typography>
          <CustomTooltip tooltipText={tooltipText}/> 
        </Grid>
      </Grid>
    </Grid>
  )
}

